import { parse, toSeconds } from "iso8601-duration";

import { getJson, post } from "../helpers/request";
import { encodeParams } from "../helpers/url";

const HISTORY_URL = `${__AREENA_API}/v1/ui/profile/history`;
const BASE_PARAMETERS = {
  language: "fi",
  v: 8
};

const urlWithBaseParamsAndKeys = `${HISTORY_URL}?${encodeParams(
  BASE_PARAMETERS
)}&${__API_KEYS}`;

const withHistoryOptions = (programId: string) => ({
  parameters: {
    ...BASE_PARAMETERS,
    "filter.id": programId
  },
  url: HISTORY_URL,
  withCredentials: true
});

interface Label {
  type: string;
  raw: string;
}

interface ProgramData {
  data: Array<{ labels: Label[] }>;
}
export const getAreenaWatchedHistoryData = async (
  programId: string
): Promise<{
  watchedDuration?: number;
}> => {
  const getHistory = async (): Promise<ProgramData> => {
    try {
      return await getJson<ProgramData>(withHistoryOptions(programId));
    } catch (e) {
      return { data: [] };
    }
  };

  const { data } = await getHistory();

  const duration = data
    .filter(d => d && d.labels)
    .flatMap(item => item.labels)
    .find(label => label && label.type === "watchedDuration");

  return {
    watchedDuration: duration ? toSeconds(parse(duration.raw)) : 0
  };
};

interface SaveHistoryBody {
  programId: string;
  time: number;
}

const withHistorySavingOptions = ({ programId, time }: SaveHistoryBody) => ({
  body: { programId, time },
  parameters: {
    ...BASE_PARAMETERS
  },
  url: HISTORY_URL,
  withCredentials: true
});

export type Save = (props: SaveHistoryBody) => void;

export const sendBeacon: Save = ({ programId, time }) => {
  if (time !== 0) {
    const data = new FormData();
    data.append("programId", programId);
    data.append("time", time.toString());
    navigator.sendBeacon(urlWithBaseParamsAndKeys, data);
  }
};

export const save: Save = ({ programId, time }) => {
  if (time !== 0) {
    post(withHistorySavingOptions({ programId, time }));
  }
};
